import React, {Component, useContext, useState} from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import {InvoicesContext} from "../../invoice/InvoiceDataManager";

const schema = yup.object().shape({
  invoiceNumber: yup.string().required("Invoice number is required."),
  invoiceAmount: yup.number().required("Invoice amount is required."),
  accountNumber: yup.string().required("Billing ID is required."),
});

function AutoLinkAccountSuccess(props) {
  let address = "1234 Road Road";

  if(props.invoice) {
    let invoice = props.invoice;
    let partner = invoice.partner_data.find(_ => _.partner_function === "RG");
    let address = partner.address_data;
    return (
      <div className="card">
        <div className="row">
          <div className={"col-12"}>
            <strong>Success</strong>
            <p>
              {address.name}<br/>
              {address.street}<br/>
              {address.city}, {address.state} {address.zip} {address.country}<br/>
            </p>
            <button type={"submit"} onClick={props.onClear} className={"btn btn-primary"}>Add Another Account</button>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

AutoLinkAccountSuccess.propTypes = {
  invoice: PropTypes.object,
  onClear: PropTypes.func,
};

export default AutoLinkAccountSuccess;
